import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showSubtitle?: boolean;
  className?: string;
  iconOnly?: boolean;
  lightText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showSubtitle = true,
  className = '',
  iconOnly = false,
  lightText = false,
}) => {
  const imgDimensions =
    size === 'sm'
      ? 'w-8 h-8'
      : size === 'lg'
      ? 'w-12 h-12'
      : size === 'xl'
      ? 'w-16 h-16'
      : 'w-10 h-10';

  const titleSize =
    size === 'sm'
      ? 'text-base'
      : size === 'lg'
      ? 'text-2xl'
      : size === 'xl'
      ? 'text-3xl'
      : 'text-lg';

  const subSize =
    size === 'sm'
      ? 'text-[10px]'
      : size === 'lg'
      ? 'text-xs'
      : size === 'xl'
      ? 'text-sm'
      : 'text-[11px]';

  return (
    <div className={`flex items-center gap-3 select-none ${className}`}>
      {/* Official logo.png */}
      <img
        src="/logo.png"
        alt="MyLife Logo"
        className={`${imgDimensions} object-contain flex-shrink-0 transition-transform duration-200 hover:scale-105 ${
          lightText
            ? 'bg-white p-1 rounded-xl shadow-sm border border-white/30'
            : 'drop-shadow-sm'
        }`}
      />

      {/* Brand Title & Subtitle */}
      {!iconOnly && (
        <div>
          <span
            className={`font-black ${titleSize} tracking-tight ${
              lightText ? 'text-white drop-shadow-xs' : 'text-slate-900 dark:text-white'
            } leading-tight block`}
          >
            MyLife
          </span>
          {showSubtitle && (
            <p
              className={`${subSize} font-medium ${
                lightText ? 'text-emerald-100/90 font-medium' : 'text-slate-500 dark:text-slate-400'
              } leading-tight mt-0.5`}
            >
              Manage Your Life
            </p>
          )}
        </div>
      )}
    </div>
  );
};

